import { Pipe, PipeTransform } from '@angular/core';
import { JobsiteOverview } from '../models/jobsite.model';

@Pipe({
    name: 'filterJobsiteTable'
})
export class FilterJobsiteTablePipe implements PipeTransform {

    transform(jobsites: JobsiteOverview[], filterText: string) {
        if (jobsites == null)
            return null;
        return jobsites.filter(j => {
            if (j.JobsiteName != null && j.JobsiteName.toLowerCase().indexOf(filterText.toLowerCase()) !== -1)
                return true;
            else if (j.Country != null && j.Country.toLowerCase().indexOf(filterText.toLowerCase()) !== -1)
                return true;
            else if (j.CustomerName != null && j.CustomerName.toLowerCase().indexOf(filterText.toLowerCase()) !== -1)
                return true;
            return false;
        });
    }

}
